// extracted by mini-css-extract-plugin
export default {"purchaseBtn":"PayhereSubscriptionForm_purchaseBtn__6209S"};